<template>
    <div class="block banner pr bannerHome" >
        
        <div class="swiper-container" id="swiperContainerHome">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in prop" :style="{background:item.bg_color}" :key="item.id" ><a target="blank" :href="item.event_value"><img class="BannerImg" :src = "item.url" /></a></div>
            </div>
        </div>
        <!-- <el-carousel height="445px" arrow="never">
            <el-carousel-item v-for="item in prop" :key="item.id" :style="{backgroundColor: item.backgroundColor,textAlign: 'center'}">
                <h3 class="small" >
                    <img :src = "item.url" />
                </h3>
            </el-carousel-item>
        </el-carousel> -->
        <div class="layer bannerNews">
            <slot name="news"/> 
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
    props: ['prop'],
    mounted() {
        new Swiper ('#swiperContainerHome', {autoplay: true,loop: true,})
    },
}
</script>
<style scoped>
    .BannerImg {
        width: 1200px;
        margin: 0 auto;
        display: block;
        height: 432px;
        object-fit: cover;
    }
</style>
<style>

    .home .banner .el-carousel__arrow--left{
        left: 300px;
    }
    .home .banner .el-carousel__arrow--right{
        left: 1200px;
    }
    .home .banner .el-carousel__arrow{
        border-radius: 5px;
        display: block!important;
        width: 35px;
        height: 70px;

    }
    .home .bannerNews{
        position: absolute;
        left: 50%;
        margin-left: -600px;
        top: 0;
    }
    .bannerHome {
        min-height: 420px;
    }
</style>

